// Normaliza somente a comparação de pesquisa; preserva o texto original.
export function normalizarTextoPesquisa(valor) {
  return String(valor ?? "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLocaleLowerCase("pt-BR");
}

export function contemTextoPesquisa(valor, pesquisa) {
  return normalizarTextoPesquisa(valor).includes(normalizarTextoPesquisa(pesquisa));
}
